<template>
  <v-dialog v-model="shown" width="500px" scrollable>
    <v-card v-if="shown"  @keydown.esc="shown = false" @click.stop>
      <v-card-title class="headline">
        <span>{{ $t('crud.filters') }}</span>
        <v-spacer />
        <v-btn icon @click.native="shown = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <form @submit.prevent="save">
        <v-card-text style="max-height: 900px">
          <v-flex v-for="field in Object.keys(fields).filter(field => fields[field].list)" :key="field">
            <crud-filter
              v-if="fields[field].filterable"
              :options="fields[field]"
              :field="field"
              v-model="value"
            />
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn class="elevation-0" type="submit" success>{{ $t('save') }}</v-btn>
          <v-spacer />
          <v-btn class="elevation-0" error @click.native="cancel">{{ $t('crud.filter.clear') }}</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import CrudFilter from './CrudFilter'

export default {
  props: ['fields', 'value'],
  data () {
    return {
      shown: false
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    save () {
      this.$emit('saved')
      this.shown = false
    },
    cancel () {
      this.$emit('cancel')
      this.shown = false
    }
  },
  components: {
    CrudFilter
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CrudFilterDialog.vue?972cc088